import React from 'react';
import { Typography, Button } from '@material-ui/core';
import styled from 'styled-components';
import { DialogBox } from '../Dialog';
import defaults from './en';
export const RecordVisitButtonsDiv = styled.div.withConfig({
  displayName: "DeleteVisitConfirmation__RecordVisitButtonsDiv",
  componentId: "owql11-0"
})(["display:flex;flex-direction:row;justify-content:end;gap:20px;margin:1rem;"]);
export const DeleteVisitConfirmation = ({
  open,
  setClosed,
  onDelete,
  okToDelete,
  deleteText
}) => {
  // handleClick controls the checkmark to dismiss the DialogBox
  // this should NOT be used for delete logic.
  const handleClick = () => {
    setClosed && setClosed();
  };

  return /*#__PURE__*/React.createElement(DialogBox, {
    title: defaults.deleteVisitConfMsgTitle,
    handleClick: () => null,
    open: open,
    noIcon: true
  }, okToDelete ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, null, deleteText || defaults.deleteVisitConfMsg), /*#__PURE__*/React.createElement(RecordVisitButtonsDiv, null, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    variant: "contained",
    color: "primary",
    onClick: onDelete
  }, defaults.deleteVisit), /*#__PURE__*/React.createElement(Button, {
    size: "small",
    variant: "contained",
    color: "primary",
    onClick: handleClick
  }, defaults.cancel))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Typography, null, defaults.canNotdeleteVisitConfMsg, " "), /*#__PURE__*/React.createElement(RecordVisitButtonsDiv, null, /*#__PURE__*/React.createElement(Button, {
    size: "small",
    variant: "contained",
    color: "primary",
    onClick: handleClick
  }, defaults.ok))));
};